import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { loadFeatures } from 'shared/thunks/demo';

import type { IConfigFeatures } from 'shared/types/features';

const initialState: IConfigFeatures = {
  loadTest: {
    status: 'init',
  },
  test: false,
};

/* istanbul ignore next */
const demoSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(loadFeatures.pending, state => {
        state.loadTest = {
          data: undefined,
          status: 'loading',
        };
      })
      .addCase(loadFeatures.fulfilled, (state, action) => {
        state.loadTest = {
          data: action.payload,
          status: 'succeed',
        };
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .addCase(loadFeatures.rejected, (state, _action) => {
        state.loadTest = {
          data: '❌',
          status: 'failed',
        };
      });
  },
  initialState,
  name: 'demo',
  reducers: {
    setFeatures: (state, action: PayloadAction<boolean>) => {
      state.test = action.payload;
    },
  },
});

export const {
  reducer: demoReducer,
  actions: { setFeatures },
} = demoSlice;
